/**
 * 处理"开始使用"按钮点击
 * @param {Object} router - Vue Router实例
 * @param {Object} store - Vuex Store实例
 * @param {string} [redirect='/workspace'] - 重定向路径
 */
export function handleStart(router, store, redirect = '/workspace') {
  const isAuthenticated = store && store.state.auth && store.state.auth.token != null
  
  if (isAuthenticated) {
    router.push(redirect)
  } else {
    router.push({
      name: 'Login',
      query: { redirect }
    })
  }
} 